import React from 'react';
import type { IconProps } from '../types';

export const OHIFLogo = (props: IconProps) => (
  <svg
    width="160"
    height="70"
    viewBox="0 0 1658 308"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 211.657C0 264.749 43.039 307.788 96.1304 307.788H371.002V96.1303C371.002 43.0389 327.963 -9.15527e-05 274.871 -9.15527e-05H0V211.657Z"
      fill="#000753"
    />
    <path
      d="M1657.37 250.11C1650.35 250.11 1644.65 244.418 1644.65 237.395V52.7517V52.7517C1651.68 52.7517 1657.37 58.4444 1657.37 65.4666V250.11V250.11Z"
      fill="#ffffff"
    />
    <path
      d="M1449.91 250.11C1443.19 250.11 1438.73 243.153 1441.53 237.049L1526.2 52.7517V52.7517C1534.96 52.7517 1542.91 57.8531 1546.57 65.8129L1631.23 250.11V250.11C1622.48 250.11 1614.53 245 1610.89 237.035L1587.84 186.535H1478.93L1449.91 250.11V250.11ZM1533.38 67.1252L1483.91 175.479H1582.86L1533.38 67.1252Z"
      fill="#ffffff"
    />
    <path
      d="M1384.09 250.11C1371.11 250.11 1360.59 239.591 1360.59 226.615V226.615C1360.59 213.639 1371.11 203.12 1384.09 203.12H1390.72C1403.7 203.12 1414.22 213.639 1414.22 226.615V226.615C1414.22 239.591 1403.7 250.11 1390.72 250.11H1384.09Z"
      fill="#ffffff"
    />
    <path
      d="M1157.92 90.3438V212.518H1217.63C1253.01 212.518 1269.04 191.234 1269.04 149.496C1269.04 113.01 1253.56 90.3438 1212.65 90.3438H1157.92ZM1139.49 250.11C1120.05 250.11 1104.3 234.354 1104.3 214.919V52.7517H1227.3C1295.02 52.7517 1324.32 92.0023 1324.32 151.431C1324.32 210.86 1293.92 250.11 1232 250.11H1139.49Z"
      fill="#ffffff"
    />
    <path
      d="M861.574 179.349V52.7517H880.007C899.442 52.7517 915.198 68.5076 915.198 87.9434V166.081C915.198 185.43 916.027 218.046 965.229 218.046C1014.43 218.046 1015.26 185.43 1015.26 166.081V52.7517H1033.69C1053.13 52.7517 1068.88 68.5076 1068.88 87.9434V179.349C1068.88 201.462 1066.12 255.638 965.229 255.638C864.338 255.638 861.574 201.462 861.574 179.349Z"
      fill="#ffffff"
    />
    <path
      d="M760.688 173.544L729.729 95.3192L698.771 173.544H760.688ZM809.053 250.11C798.215 250.11 788.479 243.485 784.501 233.404L775.061 209.478H684.398L668.366 250.11H640.926C626.635 250.11 617.052 235.428 622.806 222.346L697.389 52.7517H744.844C755.312 52.7517 764.79 58.938 769.004 68.5202L848.863 250.11H809.053Z"
      fill="#ffffff"
    />
    <path
      d="M468.972 250.11C449.536 250.11 433.78 234.354 433.78 214.919V52.7517H452.212C471.648 52.7517 487.404 68.5076 487.404 87.9434V210.86H572.452C591.888 210.86 607.643 226.615 607.643 246.051V250.11H468.972Z"
      fill="#ffffff"
    />
    <path
      d="M147.553 68.0794C140.704 61.2866 118.09 56.334 75.4776 57.3763C201.831 74.0699 224.477 189.467 54.495 253.353L327.01 253.564C306.809 174.872 256.954 6.96901 147.553 68.0794Z"
      fill="#8992FF"
      fillOpacity="0.5"
    />
    <path
      d="M233.953 68.0794C240.801 61.2866 263.416 56.334 306.028 57.3763C179.675 74.0699 157.028 189.467 327.01 253.353L54.4951 253.564C74.6967 174.872 124.552 6.96901 233.953 68.0794Z"
      fill="#8992FF"
      fillOpacity="0.5"
    />
    <path
      d="M190.79 92.9419C172.535 87.4864 163.009 83.4293 147.565 68.0776C178.643 49.7419 202.076 49.0359 233.909 68.0776C221.739 80.9812 213.241 86.4373 190.79 92.9419Z"
      fill="#8992FF"
    />
  </svg>
);

export default OHIFLogo;
